import { StdResponse, request } from "@/global/config/request";
import localStore from "@/global/store/local-store";

export function findRoofSlabSectionsByProjectId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/roof-slab-sections`, {
        params: {
            ...params,
        }
    })
}

export function findAllRoofSlabSections(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/roof-slab-sections`, {
        params: {
            ...params,
        }
    })
}

export function addRoofSlabSection(projectId: number, data: any, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/roof-slab-sections`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteRoofSlabSectionByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/roof-slab-sections/${uuid}`, {
        params: {
            ...params,
            projectId: localStore.projectId,
        }
    })
}

export function updateRoofSlabSection(uuid: string, data: any, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/roof-slab-sections/${uuid}`, data, {
        params: {
            ...params,
            projectId: localStore.projectId,
        }
    })
}

export function findRoofSlabSectionByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/roof-slab-sections/${uuid}`, {
        params: {
            ...params,
        }
    })
}
